import { useTranslation } from "react-i18next";

import { HistoryEntryCard } from "./history-entry-card";
import type { EntityHistoryEntry } from "./types";

interface FallbackHistoryItemProps {
  entry: EntityHistoryEntry;
  /** i18n namespace prefix providing `sourceLabel`, `noDetails`, `unknownType` keys */
  i18nPrefix: string;
}

export function FallbackHistoryItem({
  entry,
  i18nPrefix,
}: FallbackHistoryItemProps) {
  const { t } = useTranslation();
  const fallbackText = entry.source
    ? t(`${i18nPrefix}.sourceLabel`, { source: entry.source })
    : t(`${i18nPrefix}.noDetails`);
  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <span className="text-muted-foreground">
          {entry.changeType
            ? `${entry.changeType} — ${fallbackText}`
            : `${t(`${i18nPrefix}.unknownType`)} — ${fallbackText}`}
        </span>
      }
    />
  );
}
